const EVENT = 'document:assigned'

export function emitDocumentAssigned(documentId: string): void {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { documentId } }))
}

export function onDocumentAssigned(handler: (documentId: string) => void): () => void {
  const listener = (e: Event) => handler((e as CustomEvent).detail.documentId)
  window.addEventListener(EVENT, listener)
  return () => window.removeEventListener(EVENT, listener)
}
